import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d68df4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_3 = { class: "filters-box" }
const _hoisted_4 = {
  key: 0,
  class: "no-filters-box"
}
const _hoisted_5 = { class: "no-filters-text" }
const _hoisted_6 = {
  key: 1,
  class: "filters-list-box"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-filter filter-list-icon" }, null, -1))
const _hoisted_8 = { class: "filter-item-text" }
const _hoisted_9 = { class: "right-icons-container" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times filter-list-icon" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_imdex_btn = _resolveComponent("imdex-btn")!
  const _component_ThresholdFilterOptions = _resolveComponent("ThresholdFilterOptions")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.allActiveFilters.length == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("ssa.displayPane.thresholdFilter.noEffects")), 1)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allActiveFilters, (filter, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: i,
                class: _normalizeClass({ 'filters-list-item': true, 'disable-item': !_ctx.layerSelected(filter) })
              }, [
                _createVNode(_component_imdex_btn, {
                  disabled: !_ctx.layerSelected(filter),
                  onClick: ($event: any) => (_ctx.showFilterOptions(filter)),
                  fab: "",
                  mini: "",
                  text: ""
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 2
                }, 1032, ["disabled", "onClick"]),
                _createElementVNode("span", _hoisted_8, _toDisplayString(filter.propLabel), 1),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_imdex_btn, {
                    onClick: ($event: any) => (_ctx.hideFilter(filter)),
                    fab: "",
                    mini: "",
                    text: "",
                    disabled: !_ctx.layerSelected(filter)
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("i", {
                        class: _normalizeClass([
									'fa',
									filter.disableButDisplayFilterSlashEye
										? 'fa-eye-slash'
										: 'fa-eye',
									'filter-list-icon'
								])
                      }, null, 2)
                    ]),
                    _: 2
                  }, 1032, ["onClick", "disabled"]),
                  _createVNode(_component_imdex_btn, {
                    disabled: !_ctx.layerSelected(filter),
                    onClick: ($event: any) => (_ctx.deleteFilter(filter)),
                    fab: "",
                    mini: "",
                    text: ""
                  }, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 2
                  }, 1032, ["disabled", "onClick"])
                ])
              ], 2))
            }), 128))
          ]))
    ]),
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addNewFilter && _ctx.addNewFilter(...args))),
      ref: "tFOptionsAnchor",
      class: "add-filter"
    }, [
      _createElementVNode("span", null, _toDisplayString(_ctx.$t("ssa.displayPane.thresholdFilter.addFilter")), 1)
    ], 512),
    _createVNode(_Transition, {
      "enter-active-class": "fadeInUp",
      "leave-active-class": "fadeOutDown"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          (_ctx.thresholdFilterOptionsOpen)
            ? (_openBlock(), _createBlock(_component_ThresholdFilterOptions, {
                key: 0,
                ref: "thresholdFilterOptions",
                "activate-layer": _ctx.activateLayer,
                initialLayerValue: _ctx.initialLayerValue,
                initialPropValue: _ctx.initialPropValue
              }, null, 8, ["activate-layer", "initialLayerValue", "initialPropValue"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    })
  ]))
}